import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';


import { didPropChange } from 'utils/props';


// ===========================
// PARTIALS
// ===========================
export const VerticalScrolbar = p => <div className={cx('scrollbar', 'vertical')} {...p} />;


// ===========================
// COMPONENT
// ===========================
class CustomScrollbars extends React.Component {

  componentDidMount() {
    this.refs.scrollbars.scrollTop = this.refs.scrollbars.scrollHeight;
  }

  componentDidUpdate(prev) {
    let { stickToBottom } = this.props;
    if(stickToBottom && didPropChange(prev, this.props, 'children')) {
      let s = this.refs.scrollbars;
      s.container.firstChild.scrollTop = s.getScrollHeight();
    }
  }

  render() {
    let { className, stickToBottom, ...props } = this.props;
    return (
      <Scrollbars
        ref="scrollbars"
        className="g-scrollbars"
        renderTrackVertical={VerticalScrolbar}
        autoHide
        autoHideTimeout={1000}
        renderView={p => <div {...p} className="g-scrollbar-view" />}
        {...props} />);
  }
}
export default CustomScrollbars;